module.exports = __webpack_public_path__ + "img/61.4e6f51b0.jpg";